import React, { useState } from "react";
import { Button, Dialog, Input } from "@material-tailwind/react";
import { XMarkIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline";

const suggestions = {
  "Ateliers & Projets": [
    { label: "Construire ton premier robot avec Micro:bit", link: "/ateliers/robot" },
    { label: "Atelier design 3D : modélise et imprime tes créations", link: "/ateliers/design3d" },
  ],
  "Tuteurs & Mentors": [
    { label: "Devenir tuteur GoNextMaker", link: "/tuteurs/candidature" },
    { label: "Nos mentors en électronique et robotique", link: "/tuteurs" },
  ],
  "Blog": [
    { label: "Pourquoi l’apprentissage par la pratique change la donne en Afrique", link: "/blog/apprentissage-par-pratique" },
    { label: "Retour sur le Summer Camp 2025", link: "/blog/summercamp-2025" },
  ],
  "FAQ & Aide": [
    { label: "Comment m’inscrire à un atelier ?", link: "/faq/inscription" },
    { label: "Que faire si j’ai oublié mon mot de passe ?", link: "/faq/mot-de-passe" },
  ],
};

const SearchButton = () => {
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const handleOpen = () => setOpen(!open);

  // Filtrer suggestions
  const filteredSuggestions = Object.entries(suggestions).reduce(
    (acc, [category, items]) => {
      const filteredItems = items.filter((item) =>
        item.label.toLowerCase().includes(searchQuery.toLowerCase())
      );
      if (filteredItems.length > 0) acc[category] = filteredItems;
      return acc;
    },
    {}
  );

  // Fonction redirection Entrée
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      window.location.href = `/search?query=${encodeURIComponent(searchQuery)}`;
    }
  };

  return (
    <>
      {/* Bouton ouverture */}
      <Button
        variant="text"
        className="flex items-center text-dark-1 p-2 hover:text-purple-1"
        onClick={handleOpen}
      >
        <MagnifyingGlassIcon className="h-5 w-5" />
      </Button>

      {/* Dialog */}
      <Dialog
        open={open}
        handler={handleOpen}
        size="xl"
        className="bg-white shadow-xl rounded-lg max-h-[600px] overflow-y-auto"
      >
        <div className="pt-24 px-6 pb-12">
          <div className="container mx-auto">
            {/* Barre de recherche */}
            <div className="relative flex items-center border-b-2 border-gray-200 pb-4 focus-within:border-blue-1">
              <MagnifyingGlassIcon className="h-6 w-6 text-dark-1 mr-4" />
              <Input
                type="text"
                className="w-full h-full text-xl border-none font-medium text-black outline-none"
                placeholder="Rechercher un atelier, un tuteur, un article..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={handleKeyDown} // ← capture Entrée
                containerProps={{ className: "min-w-[100px]" }}
                labelProps={{ className: "hidden" }}
              />
              <Button
                variant="text"
                className="p-2 rounded-full bg-light-2 hover:bg-light-3 ml-4"
                onClick={handleOpen}
              >
                <XMarkIcon className="h-5 w-5 text-dark-1" />
              </Button>
            </div>

            {/* Résultats */}
            <div className="mt-8 space-y-6">
              {Object.keys(filteredSuggestions).length > 0 ? (
                Object.entries(filteredSuggestions).map(([category, items]) => (
                  <div key={category}>
                    <h4 className="text-lg font-semibold text-dark-1 mb-3">
                      {category}
                    </h4>
                    <ul className="space-y-2">
                      {items.map((item, i) => (
                        <li key={i}>
                          <a
                            href={item.link}
                            className="text-dark-1 hover:text-purple-1 transition-colors"
                          >
                            {item.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))
              ) : (
                <p className="text-light-1 italic">
                  Aucun résultat trouvé pour « {searchQuery} »
                </p>
              )}
            </div>

            {/* CTA bas */}
            <div className="mt-10 text-center">
              <button
                onClick={() =>
                  (window.location.href = `/search?query=${encodeURIComponent(
                    searchQuery
                  )}`)
                }
                className="uppercase text-sm font-medium text-dark-1 hover:text-blue-1 underline"
              >
                Appuie sur Entrée pour voir tous les résultats
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default SearchButton;
